/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue";
import { apiGSIncomeCurrentList } from '@/api/gsManage';
import { useModel } from '@ultra/share/hooks/index';
export default /*#__PURE__*/_defineComponent({
  __name: 'selectCurrency',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue', 'onChange'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const currencyList = ref();
    const emits = __emit;
    const currency = useModel(() => props.modelValue, val => emits('update:modelValue', val));
    const getCurrencyList = async () => {
      const res = await apiGSIncomeCurrentList({});
      if (res.code === 0) {
        currencyList.value = res.data;
      }
    };
    const handleChange = val => {
      emits('onChange', val);
    };
    onMounted(() => {
      getCurrencyList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_select, {
        modelValue: _unref(currency),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currency) ? currency.value = $event : null),
        style: {
          "width": "160px"
        },
        onChange: handleChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyList), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.name,
            value: item.currency
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});